import Storage from 'utils/storage/generator';

export const todoStorage = new Storage('todos');
